import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _28843ade = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages/error" */))
const _960407f0 = () => interopDefault(import('..\\pages\\tradeGold\\goldIndex.vue' /* webpackChunkName: "pages/tradeGold/goldIndex" */))
const _f3a74c18 = () => interopDefault(import('..\\pages\\categories\\_id.vue' /* webpackChunkName: "pages/categories/_id" */))
const _103bd1a8 = () => interopDefault(import('..\\pages\\products\\_id.vue' /* webpackChunkName: "pages/products/_id" */))
const _3683c6b0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _11405278 = () => interopDefault(import('..\\store\\index.js' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _28843ade,
    name: "error"
  }, {
    path: "/tradeGold/goldIndex",
    component: _960407f0,
    name: "tradeGold-goldIndex"
  }, {
    path: "/categories/:id?",
    component: _f3a74c18,
    name: "categories-id"
  }, {
    path: "/products/:id?",
    component: _103bd1a8,
    name: "products-id"
  }, {
    path: "/",
    component: _3683c6b0,
    name: "index"
  }, {
    path: "/vuex",
    component: _11405278,
    name: "vuex"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
